export class CoreUtils {
  static debounce = <T extends (...args: any[]) => void>(callback: T, wait: number): ((...args: Parameters<T>) => void) => {
    let timeoutId: NodeJS.Timeout | null = null;

    return (...args: Parameters<T>): void => {
      if (timeoutId !== null) clearTimeout(timeoutId);
      timeoutId = setTimeout(() => callback(...args), wait);
    };
  };
}
